import React from 'react';

/**
 * Study streak display — flame icon + day count.
 */
export default function StreakDisplay({ currentStreak, longestStreak }) {
  if (currentStreak === 0 && longestStreak === 0) return null;

  return (
    <div className="flex items-center justify-center gap-4 mb-6">
      {currentStreak > 0 && (
        <div className="flex items-center gap-2 bg-orange-900/30 border border-orange-700/30 rounded-full px-4 py-2">
          <span className="text-xl">🔥</span>
          <span className="text-orange-300 font-bold">{currentStreak} day streak</span>
        </div>
      )}
      {longestStreak > currentStreak && longestStreak > 1 && (
        <div className="text-sm text-gray-500">
          Best: {longestStreak} days
        </div>
      )}
    </div>
  );
}
